"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 8.646c-1.849 0-3.354 1.504-3.354 3.354S10.15 15.354 12 15.354 15.352 13.85 15.352 12 13.848 8.646 12 8.646m0 5.551c-1.212 0-2.197-.986-2.197-2.197S10.789 9.803 12 9.803s2.196.986 2.196 2.197-.986 2.197-2.196 2.197"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20.672 11.422h-.926a7.78 7.78 0 0 0-7.168-7.168v-.926a.578.578 0 1 0-1.156 0v.926a7.78 7.78 0 0 0-7.169 7.168h-.925a.578.578 0 1 0 0 1.156h.925a7.78 7.78 0 0 0 7.169 7.168v.926a.578.578 0 1 0 1.156 0v-.926a7.78 7.78 0 0 0 7.168-7.168h.926a.578.578 0 1 0 0-1.156M12 18.619c-3.651 0-6.62-2.97-6.62-6.619S8.35 5.381 12 5.381s6.619 2.97 6.619 6.619-2.97 6.619-6.619 6.619"
  })]
}), 'MapSelector');
//# sourceMappingURL=index.js.map